import React, { Component } from 'react';
import {Topic, TextHolder, Footer, ExploreData} from '../../Components/contentHolders/contentHolders.js';








export class ChapterTwenty extends Component {

  render() {
    return (
      <section className="Content">
        <div className="content-holder-topic">
        <div className="content-holder-inner fade">

        <Topic topicNumber={this.props.topicNumber} topicTitle={this.props.topicTitle} topicText={this.props.topicText} />

        <TextHolder text="For SEA’s tech startup industry, the highlights of 2017 included record-breaking raises, forays into frontier tech (e.g., artificial intelligence and machine learning; blockchain and cryptocurrency) and increased attention from international venture capital firms and corporate investors."/>


        <ExploreData nextChapter={ this.props.nextChapter } />
        <Footer />

        </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/20.js